import CityPageTemplate from "../city-template/CityPageTemplate";
import { hamptonVaConfig } from "./data";

export default function HamptonVaPage() {
  return <CityPageTemplate config={hamptonVaConfig} />;
}